"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _parseInt = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/parse-int"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _Button = _interopRequireDefault(require("../../Button"));

var types = _interopRequireWildcard(require("../../types"));

var _iconButtonSizes;

var iconButtonSizes = (_iconButtonSizes = {}, (0, _defineProperty2["default"])(_iconButtonSizes, types.SMALL, (0, _styledComponents.css)(["font-size:14px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(3), (0, _parseInt["default"])(_tokens["default"].space, 10) * 3 - 2, _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_iconButtonSizes, types.MEDIUM, (0, _styledComponents.css)(["font-size:18px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(4), (0, _parseInt["default"])(_tokens["default"].space, 10) * 4 - 2, _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_iconButtonSizes, types.LARGE, (0, _styledComponents.css)(["font-size:22px;height:", ";line-height:", "px;padding:0;width:", ";"], _stylers["default"].spacer(5), (0, _parseInt["default"])(_tokens["default"].space, 10) * 5 - 2, _stylers["default"].spacer(5))), _iconButtonSizes);

var minorStyles = function minorStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return (0, _styledComponents.css)(["transition:background-color 0.2s ease-out;", ""], isDisabled ? (0, _styledComponents.css)(["&,&:hover,&:active{[data-pka-anchor=\"button.icon\"] svg{color:", ";}}"], _tokens["default"].color.blackDisabled) : (0, _styledComponents.css)(["&:hover{background-color:", ";}&:active{background-color:", ";}"], _stylers["default"].alpha(_tokens["default"].color.black, 0.1), _stylers["default"].alpha(_tokens["default"].color.black, 0.2)));
};

var IconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "IconButtonstyles__IconButton",
  componentId: "sc-1rmwp4p-0"
})(function (_ref2) {
  var size = _ref2.size,
      kind = _ref2.kind;
  return (0, _styledComponents.css)(["", " ", " [data-pka-anchor=\"button.icon\"]{color:inherit;margin:0;}"], iconButtonSizes[size], kind === types.MINOR ? minorStyles : "");
});
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.styles.js.map